import { Component, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { ChatStateService } from '../../../../core/services/chat-state.service';
import { ChatOrchestratorService } from '../../../../core/services/chat-orchestrator.service';
import { GraphModalService } from '../../../../core/services/graph-modal.service';
import { ChunkEditorService } from '../../../../core/services/chunk-editor.service';
import { Message } from '../../../../core/models/chat.models';

import { GraphViewerComponent } from '../graph-viewer/graph-viewer.component';
import { EditChunksModalComponent } from '../edit-chunks-modal/edit-chunks-modal.component';
import { ChatMessageListComponent } from '../chat-message-list/chat-message-list.component';
import { ChatInputComponent } from '../chat-input/chat-input.component';

@Component({
  selector: 'app-chat-area',
  imports: [
    CommonModule,
    GraphViewerComponent,
    EditChunksModalComponent,
    ChatMessageListComponent,
    ChatInputComponent
  ],
  host: {
    'class': 'flex-1 flex flex-col h-full w-full overflow-hidden'
  },
  providers: [
    ChatOrchestratorService,
    GraphModalService,
    ChunkEditorService
  ],
  templateUrl: './chat-area.component.html',
  styleUrls: ['./chat-area.component.scss']
})
export class ChatAreaComponent implements OnInit, OnDestroy {
  @ViewChild('messagesEnd') messagesEnd!: ElementRef;

  messages: Message[] = [];
  activeId: string | null = null;
  isLoading = false;

  private destroy$ = new Subject<void>();

  constructor(
    public chatState: ChatStateService,
    public chatOrchestrator: ChatOrchestratorService,
    public graphModal: GraphModalService,
    public chunkEditor: ChunkEditorService
  ) { }

  ngOnInit(): void {
    this.chatState.messages$.pipe(takeUntil(this.destroy$)).subscribe(
      messages => {
        this.messages = messages;
        setTimeout(() => this.scrollToBottom(), 100);
      }
    );

    this.chatState.id$.pipe(takeUntil(this.destroy$)).subscribe(
      activeId => this.activeId = activeId
    );

    this.chatState.isLoading$.pipe(takeUntil(this.destroy$)).subscribe(
      loading => this.isLoading = loading
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private scrollToBottom(): void {
    try {
      this.messagesEnd?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
    } catch (e) {
      console.error('Error scrolling:', e);
    }
  }

  handleSendMessage(inputStr: string): void {
    this.chatOrchestrator.handleSendMessage(inputStr, this.activeId);
  }
}
